import feathersClient, { makeServicePlugin, BaseModel } from '@/api-client'

class OrderCSV extends BaseModel {
  static modelName = 'OrderCSV'
}
const servicePath = 'orders-csv'
const servicePlugin = makeServicePlugin({
  Model: OrderCSV,
  // IMPORTANT
  whitelist: ['$eager', '$regex', '$options'],
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
